module.exports = __webpack_public_path__ + "img/spin-wheel-face-night-v2.3934db12.png";